import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07b85937"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-wrap"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "van-badge__wrapper van-icon van-icon-arrow van-cell__right-icon",
  style: { marginRight: '10px' }
}, null, -1))
const _hoisted_3 = {
  key: 2,
  class: "check-info-wrap"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "value" }

import { computed, onMounted, Ref, ref, watch } from 'vue'
import { Form, Field, CellGroup, Popup, Cascader } from 'vant'
import type { FieldRule, CascaderOption } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { MalfunctionRepairAddressInfoStorage } from '@/storage/malfunction-repair'
import {
  useMalfunctionRepairStore,
  useMalfunctionRepairAddressInfo,
} from '@/compositions/malfunction-repair/index'
import AppHeader from '@/components/Header.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import { getAreaList } from '@/apis/malfunction-repair'
import { clearToast, showToastFail, showToastLoading } from '@/utils/tools'
import { AreaStorageData } from '@/types/malfunction-repair'
type AreaChangData = {
  selectedOptions: Array<CascaderOption>
  tabIndex: number
  value: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-address',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const isChecked = !!($route.query.check as string)
const { malfunctionRepairState } = useMalfunctionRepairStore()

let areaErrorMessage = ref('')
let form = ref({
  name: '',
  phone: '',
  address: '',
  area: '',
})

const nameRule: FieldRule[] = [{ required: true, trigger: 'onBlur', message: '请输入姓名' }]
const phoneRule: FieldRule[] = [{ required: true, trigger: 'onBlur', message: '请输入电话' }]
const areaRules: FieldRule[] = [
  {
    required: true,
    trigger: 'onBlur',
    message: '请选择所在地区',
    validator: (value: string) => {
      return !!value.length
    },
  },
]
const addressRules: FieldRule[] = [
  {
    required: true,
    trigger: 'onBlur',
    message: '请输入详细地址',
  },
]
let addressShow = ref(false)
let cascaderValue = ref()
let areaOption = ref([])
const { getAddressAreaStr } = useMalfunctionRepairAddressInfo()
const checkInfoList = computed(() => {
  if (!isChecked) {
    return []
  }
  const data = malfunctionRepairState.orderDetailLogistics
  console.log('data', data)
  return [
    { title: '姓名', value: data.name },
    { title: '电话', value: data.phone },
    { title: '地区', value: getAddressAreaStr({ ...data }) },
    { title: '详细地址', value: data.address },
  ]
})

watch(
  () => addressShow.value,
  () => {
    if (!form.value.area.length) {
      areaErrorMessage.value = '请选择所在地区'
    } else {
      areaErrorMessage.value = ''
    }
  }
)

onMounted(async () => {
  try {
    if (isChecked) {
      return
    }
    showToastLoading()
    // 根据是否回显加载相应的值
    let data: AreaStorageData = MalfunctionRepairAddressInfoStorage.get()
    if (data !== null) {
      console.log('data', data)
      form.value.name = data.name
      form.value.phone = data.phone
      form.value.address = data.address
      form.value.area = [data.province, data.city, data.area]
        .filter((_) => !['', undefined].includes(_))
        .join('/')
      // 回显
      cascaderValue.value = data.areaID
      areaTextArr.value = [data.province, data.city, data.area]
      areaValueArr.value = [data.provinceID, data.cityID, data.areaID]
      let optionData = await Promise.all([
        getAreaList({
          level: 1,
          upid: 0,
        }),
        getAreaList({
          level: 2,
          upid: data.provinceID,
        }),
        getAreaList({
          level: 3,
          upid: data.cityID,
        }),
      ])
      areaOption.value = optionData[0].map((provinceItem) => {
        let result = {
          text: provinceItem.name,
          value: provinceItem.id,
          level: 1,
          children: [] as CascaderOption,
        }
        if (provinceItem.id === data.provinceID) {
          result.children = optionData[1].map((cityItem) => {
            let result = {
              text: cityItem.name,
              value: cityItem.id,
              level: 2,
              children: [] as CascaderOption,
            }
            if (cityItem.id === data.cityID) {
              result.children = optionData[2].map((areaItem) => {
                return {
                  text: areaItem.name,
                  value: areaItem.id,
                  level: 3,
                }
              })
            }
            return result
          })
        }
        return result
      })
    } else {
      let option = await getAreaList({
        level: 1,
        upid: 0,
      })
      areaOption.value = option.map((_) => {
        return {
          text: _.name,
          value: _.id,
          level: 1,
          children: [],
        }
      })
    }
    clearToast()
  } catch (e) {
    clearToast()
  }
})

const areaChange = async (data: AreaChangData) => {
  try {
    // 判断最后
    console.log('data', data)
    let length = data.selectedOptions.length
    if (length >= 3) {
      addressShow.value = false
      form.value.area = data.selectedOptions.map((option) => option.text).join('/')
      delete data.selectedOptions[length - 1].children
      return
    }
    showToastLoading()
    let option = await getAreaList({
      level: data.selectedOptions[length - 1].level + 1,
      upid: data.value,
    })
    data.selectedOptions[length - 1].children = option.map((_) => {
      let optionItem: {
        text: string
        value: number
        level: number
        children?: []
      } = {
        text: _.name,
        value: _.id,
        level: data.selectedOptions[length - 1].level + 1,
      }
      if (_.has_son) {
        optionItem.children = []
      }
      return optionItem
    })
    clearToast()
  } catch (e) {
    clearToast()
  }
}

let areaValueArr = ref([])
let areaTextArr = ref([])
const areaFinish = (data: AreaChangData) => {
  addressShow.value = false
  form.value.area = data.selectedOptions.map((option) => option.text).join('/')
  areaValueArr.value = data.selectedOptions.map((option) => option.value)
  areaTextArr.value = data.selectedOptions.map((option) => option.text)
  let length = data.selectedOptions.length
  delete data.selectedOptions[length - 1].children
  console.log('areaFinish', data)
  // 设置值
}

function onSave() {
  // 校验
  let message = ''
  if (form.value.name === '') {
    message = '请输入姓名'
  } else if (form.value.phone === '') {
    message = '请输入电话'
  } else if (form.value.area === '') {
    message = '请选择所在地区'
  } else if (form.value.address === '') {
    message = '请输入详细地址'
  }
  if (message) {
    showToastFail(message)
    return
  }
  let data = {
    name: form.value.name,
    phone: form.value.phone,
    province: areaTextArr.value[0],
    city: areaTextArr.value[1],
    area: areaTextArr.value[2],
    address: form.value.address,
    provinceID: areaValueArr.value[0],
    cityID: areaValueArr.value[1],
    areaID: areaValueArr.value[2],
  }
  MalfunctionRepairAddressInfoStorage.set(data)
  $router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: isChecked ? '查看回寄地址' : '编辑回寄地址'
    }, null, 8, ["title"]),
    (!isChecked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Form), { class: "form" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CellGroup), { class: "form-cell" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Field), {
                    label: "姓名",
                    placeholder: "姓名",
                    modelValue: _unref(form).name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
                    rules: nameRule
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(Field), {
                    label: "电话",
                    placeholder: "电话",
                    modelValue: _unref(form).phone,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).phone) = $event)),
                    rules: phoneRule
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(Field), {
                    modelValue: _unref(form).area,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).area) = $event)),
                    readonly: "",
                    label: "地区",
                    "label-width": "100%",
                    "error-message": _unref(areaErrorMessage),
                    placeholder: "请选择所在地区",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(addressShow) //@ts-ignore
 ? addressShow.value = true : addressShow = true)),
                    rules: areaRules
                  }, {
                    "right-icon": _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 8, ["modelValue", "error-message"]),
                  _createVNode(_unref(Popup), {
                    show: _unref(addressShow),
                    "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_isRef(addressShow) ? (addressShow).value = $event : addressShow = $event)),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Cascader), {
                        modelValue: _unref(cascaderValue),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(cascaderValue) ? (cascaderValue).value = $event : cascaderValue = $event)),
                        title: "请选择所在地区",
                        options: _unref(areaOption),
                        onClose: _cache[5] || (_cache[5] = ($event: any) => (_isRef(addressShow) //@ts-ignore
 ? addressShow.value = false : addressShow = false)),
                        onChange: areaChange,
                        onFinish: areaFinish
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  }, 8, ["show"]),
                  _createVNode(_unref(Field), {
                    modelValue: _unref(form).address,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).address) = $event)),
                    label: "详细地址",
                    placeholder: "详细地址",
                    rules: addressRules
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!isChecked)
      ? (_openBlock(), _createBlock(CommonFooterNextButton, {
          key: 1,
          onClick: onSave,
          title: "保存并使用"
        }))
      : _createCommentVNode("", true),
    isChecked
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkInfoList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["check-info", index > 0 ? 'van-hairline--top' : '']),
              key: index
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.value), 1)
              ])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})